import React from "react";
import { useLocation } from "react-router-dom";
import { hideDetails } from "../utilities/PageVisibiltyHandler";
import { auth } from "../firebase";

const ADMIN_EMAIL = "johnnymoran44@hotmail.com";

export default function WhatsAppLink({ userData, isMutual }) {
	const location = useLocation();
	const message = "Hello! We met at the Get2Know event!";
	const whatsAppUrl = `https://wa.me/${userData?.phoneNumber}?text=${encodeURIComponent(message)}`;
	const isProfilePage = hideDetails.some((path) => location.pathname.startsWith(path));
	const isAdmin = auth.currentUser?.email === ADMIN_EMAIL;

	return (
		<>
			{!isProfilePage && (
				<p>
					<i className="bi bi-telephone me-2"></i>
					<span>{userData?.phoneNumber || "(Add your phone number)"}</span>
				</p>
			)}
			{isProfilePage && (isMutual || isAdmin) && (
				<>
					{userData?.phoneNumber ? (
						<>
							<p className="mt-2">
								<i className="bi bi-telephone me-2"></i>
								<span>{userData?.phoneNumber}</span>
							</p>
							<a
								href={whatsAppUrl}
								target="_blank"
								rel="noopener noreferrer"
								className="btn btn-success d-inline-flex align-items-center mt-1"
							>
								<i className="bi bi-whatsapp me-2"></i>
								Chat on WhatsApp
							</a>
						</>
					) : (
						<p className="text-muted mt-1">
							<i className="bi bi-whatsapp me-2"></i>
							{userData?.displayName || "This user"} hasn't saved their phone number.
						</p>
					)}
					<p className="mt-2">
						<i className="bi bi-envelope me-2"></i>
						<span>{userData?.email}</span>
					</p>
				</>
			)}
		</>
	);
}
